import { render, staticRenderFns } from "./GeneralServiceContent.vue?vue&type=template&id=24ab106e&"
import script from "./GeneralServiceContent.vue?vue&type=script&lang=js&"
export * from "./GeneralServiceContent.vue?vue&type=script&lang=js&"
import style0 from "./GeneralServiceContent.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports